interface CacheUtilOptions {
    key: string;
    value?: any;
    defaultValue?: void;
  }
  
  class CacheUtil {
    // 存储单个属性
    set(options: CacheUtilOptions): void {
      const { key, value } = options;
      if (value !== undefined) {
        window.localStorage[key] = String(value); // 将值转换为字符串类型以符合localStorage要求
      }
    }
  
    // 读取单个属性
    get(options: CacheUtilOptions): void {
      const { key, defaultValue } = options;
      const storedValue = window.localStorage[key];
      return storedValue ? JSON.parse(storedValue) : defaultValue; // 假设从localStorage读取的值都是JSON格式化过的
    }
  
    // 存储对象，以JSON格式存储
    setObject(options: CacheUtilOptions): void {
      const { key, value } = options;
      if (value !== undefined) {
        window.localStorage[key] = JSON.stringify(value);
      }
    }
  
    // 读取对象
    getObject(options: CacheUtilOptions): void {
      const { key } = options;
      const storedValue = window.localStorage[key];
      return storedValue ? JSON.parse(storedValue) : null;
    }
  
    // 删除某一键值对
    removeItem(key: string): void {
      window.localStorage.removeItem(key);
    }
  
    // 清空整个localStorage
    clearLocalStorage(): void {
      window.localStorage.clear();
    }
  }
  
  export const cacheUtil = new CacheUtil();